import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';

const CafeAboutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  [theme.breakpoints.down('850')]: {
    gap: '20px',
    width: '300px',
    marginLeft: '83px',
  },
  [theme.breakpoints.down('450')]: {
    gap: '15px',
    width: '300px',
    marginLeft: '1px',
  },
  [theme.breakpoints.down('370')]: {
    gap: '15px',
    width: '300px',
    marginRight: '15px',
  },
}));

const AddressTypography = styled(Typography)(() => ({
  fontFamily: 'Raleway',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '16px',
  display: 'flex',
  gap: '6px',
  alignItems: 'center',
  color: '#000000',
}));
const TelephoneTypography = styled(Typography)(() => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '21px',
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: '#000000',
}));

const hashtag = [
  'BACON & EGGS',
  'RIVIERA OMELETTE',
  'CRISPY BACON WAFFLE',
  'BACON PANCAKES',
  'CHEF SALAD',
];

const CafeHashtagTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Raleway',
  fontSize: '14px',
  fontWeight: '700',
  color: '#000000',
  [theme.breakpoints.down('850')]: {
    padding: '0 25px 0 0',
  },
  [theme.breakpoints.down('450')]: {
    padding: '0 70px 0 0px',
    fontSize: '13px',
  },
  [theme.breakpoints.down('370')]: {
    padding: '0 50px 0 0px',
    fontSize: '13px',
  },
}));

export const CafeTrendingHashtag = () => {
  return (
    <CafeHashtagTypography>
      {hashtag.map((trending, index) => {
        return <span key={index}>#{trending}</span>;
      })}
    </CafeHashtagTypography>
  );
};

const CafeAbout = ({ cafeData }) => {
  return (
    <CafeAboutContainer>
      <AddressTypography>
        <LocationOnIcon sx={{ color: 'rgba(0, 0, 0, 0.54)' }} />
        <span>
          {cafeData.cafeAddress.streetNumber} {cafeData.cafeAddress.streetName},{' '}
          {cafeData.cafeAddress.city}, {cafeData.cafeAddress.state}, {cafeData.cafeAddress.postcode}
        </span>
      </AddressTypography>
      <TelephoneTypography>
        <PhoneEnabledIcon sx={{ color: 'rgba(0, 0, 0, 0.54)' }} />
        <span>{cafeData.cafePhone}</span>
      </TelephoneTypography>
      <CafeTrendingHashtag />
    </CafeAboutContainer>
  );
};

export default CafeAbout;
